import { CategoryService } from '@modules/category/category-service';
import Errors from '@shared/error/errors';
import Message from '@shared/message/message';
import { i18n } from '@shared/i18n';
import ManageModel from '@shared/manage/manage-model';
import { routerAsync } from '@/app-module';

export default {
  namespaced: true,

  state: {
    findLoading: false,
    saveLoading: false,
    record: null,
  },

  getters: {
    record: (state) => state.record,
    findLoading: (state) => !!state.findLoading,
    saveLoading: (state) => !!state.saveLoading,
  },

  mutations: {
    RESET(state) {
      state.findLoading = false;
      state.saveLoading = false;
      state.record = null;
    },

    FIND_STARTED(state) {
      state.record = null;
      state.findLoading = true;
    },

    FIND_SUCCESS(state, payload) {
      state.record = payload;
      state.findLoading = false;
    },

    FIND_ERROR(state) {
      state.record = null;
      state.findLoading = false;
    },

    CREATE_STARTED(state) {
      state.saveLoading = true;
    },

    CREATE_SUCCESS(state) {
      state.saveLoading = false;
    },

    CREATE_ERROR(state) {
      state.saveLoading = false;
    },

    UPDATE_STARTED(state) {
      state.saveLoading = true;
    },

    UPDATE_SUCCESS(state) {
      state.saveLoading = false;
    },

    UPDATE_ERROR(state) {
      state.saveLoading = false;
    },
  },

  actions: {
    doNew({ commit }) {
      commit('RESET');
    },

    async doFind({ commit }, {id, manage}) {
      try {
        commit('FIND_STARTED');
        const manageInput = new ManageModel(manage ).getManageModel()
        const record = await CategoryService.find(id, manageInput);

        commit('FIND_SUCCESS', record);
      } catch (error) {
        Errors.handle(error, () => {
          commit('FIND_ERROR');
        });
      }
    },

    async doCreate({ commit, dispatch, rootGetters }, {values, manage}) {
      try {
        commit('CREATE_STARTED');
        const manageInput = new ManageModel(manage ).getManageModel();
      
        await CategoryService.create(values, manageInput);
        
        dispatch('subproperty/requirements/doFetch', {
          propertyId: manage.property.id,
          subpropertyId: manage.subproperty.id,
          userId: rootGetters['auth/currentUser'].id
        }, {
          root: true
        });

        commit('CREATE_SUCCESS');
        Message.success(i18n('entities.category.create.success'));
        routerAsync().go(-1);
      } catch (error) {
        Errors.handle(error, () => {
          commit('CREATE_ERROR');
        });
      }
    },

    async doUpdate({ commit }, { id, values, manage }) {
      try {
        commit('UPDATE_STARTED');
        const manageInput = new ManageModel(manage ).getManageModel()
        await CategoryService.update(id, values, manageInput);

        commit('UPDATE_SUCCESS');
        Message.success(i18n('entities.category.update.success'));
        routerAsync().go(-1);
      } catch (error) {
        Errors.handle(error, () => {
          commit('UPDATE_ERROR');
        });
      }
    },
  },
};
